import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61141ba7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bg-tradelaboBlue text-white p-2 h-11"
}
const _hoisted_2 = { class: "grid grid-cols-12" }
const _hoisted_3 = { class: "col-span-2 flex items-center" }
const _hoisted_4 = { class: "col-span-8 flex items-center justify-center" }
const _hoisted_5 = { class: "col-span-2 flex items-center justify-end" }
const _hoisted_6 = {
  key: 1,
  class: "bg-white text-gray-500 p-2 h-12"
}
const _hoisted_7 = { class: "grid grid-cols-12" }
const _hoisted_8 = { class: "col-span-1 flex items-center justify-start" }
const _hoisted_9 = { class: "col-span-11 flex items-center justify-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_svg_icon = _resolveComponent("base-svg-icon")!
  const _component_base_logo = _resolveComponent("base-logo")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_search_box = _resolveComponent("search-box")!

  return (!_ctx.store.state.layout.searchHistory.open)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_layouts_auth_width, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_Transition, {
                  name: "fade",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (!_ctx.store.state.layout.sidebar.open)
                      ? (_openBlock(), _createBlock(_component_base_svg_icon, {
                          key: 0,
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.store.dispatch('layout/switchSidebarOpen'))),
                          class: "w-6 cursor-pointer",
                          path: _ctx.mdiMenu
                        }, null, 8, ["path"]))
                      : (_openBlock(), _createBlock(_component_base_svg_icon, {
                          key: 1,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.store.dispatch('layout/switchSidebarOpen'))),
                          class: "w-6 cursor-pointer",
                          path: _ctx.mdiClose
                        }, null, 8, ["path"]))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_router_link, { to: _ctx.homePath }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_logo, { class: "h-7" })
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                (!_ctx.store.state.layout.sidebar.open)
                  ? (_openBlock(), _createBlock(_component_base_svg_icon, {
                      key: 0,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.store.dispatch('layout/switchsearchHistoryOpen'))),
                      class: "w-6 fill-current flex justify-center item-center",
                      path: _ctx.mdiMagnify
                    }, null, 8, ["path"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createVNode(_component_layouts_auth_width, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_base_svg_icon, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.store.dispatch('layout/switchsearchHistoryOpen'))),
                  class: "w-6 cursor-pointer mt-1",
                  path: _ctx.mdiArrowLeft
                }, null, 8, ["path"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_search_box)
              ])
            ])
          ]),
          _: 1
        })
      ]))
}